'use client'

import React from 'react'
import { CollectionArchive } from '@/ui/components/CollectionArchive'
import { CardType } from '@/ui/components/Card/types'
import type { BaseGatedArchiveClientProps } from '../shared/gatedArchiveTypes'

/**
 * Props for ListedProductsByGroupClient component
 */
export interface ListedProductsByGroupClientProps extends BaseGatedArchiveClientProps {
  // No additional props needed - all inherited from base
}

/**
 * Client component for ListedProductsByGroup
 *
 * Displays products filtered by their product group.
 * All gating, authentication, and rendering logic is handled by CollectionArchive.
 */
export const ListedProductsByGroupClient: React.FC<ListedProductsByGroupClientProps> = ({
  initialData,
  fetchCollectionDataAction,
  isGated,
  gateConfig,
  where,
  locale,
  limit,
  gridCols,
  archiveId,
  title,
  titleHierarchy,
  fixedTitleStyle,
  introContent,
  emptyStateType,
  emptyStateButton,
  emptyStateHasButton,
}) => {
  return (
    <CollectionArchive
      archiveId={archiveId}
      initialData={initialData}
      fetchCollectionDataAction={fetchCollectionDataAction}
      collection="products"
      locale={locale}
      where={where}
      limit={limit}
      gridCols={gridCols}
      cardType={CardType.StandardFavorite}
      loadMoreStrategy="none"
      // Gating props
      isGated={isGated}
      gateConfig={gateConfig}
      // Title props (passed to ArchiveHeader)
      title={title ?? undefined}
      titleHierarchy={titleHierarchy}
      fixedTitleStyle={fixedTitleStyle}
      introText={introContent}
      // Empty state props
      emptyStateType={emptyStateType}
      emptyStateButton={emptyStateButton}
      emptyStateHasButton={emptyStateHasButton}
      // Tracking
      enableTracking={true}
    />
  )
}
